import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'has_fac_threatened_intimidated_harassed_punished_terminated_not'

export const dataPointDefinition = {
  retracedId: 'has_fac_threatened_intimidated_harassed_punished_terminated_not',
  name: 'Has the facility threatened, intimidated, harassed, punished, terminated or not renewed worker contracts due to their wo',
  description:
    'This question is about retaliation against workers for their representative role or activities (not including trade union membership or activities, which are covered separately). This question covers non-union worker representatives, including those serving on, e.g., OSH committees, bipartite commit',
  meta: {
    slcpMeta: {
      key: 'erg-2--1',
      number: 'WI-WOR-3',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'erg-2--1', version: '1.7.0', provider: 'slcp'}],
  sortingId: 27050,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
